import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from 'utils/request';
import { EVENTS_CUSTOM_FIELDS_KEY } from './useEventCustomFieldDefinitions';

function reorderEventCustomFieldDefinitions({
  schoolyearId,
  schoolId,
  ids,
}: {
  schoolyearId: string;
  schoolId: string;
  ids: string[];
}) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/events-custom-fields/reorder`,
    {
      method: 'PATCH',
      body: { ids },
    },
  );
}

export const useReorderEventCustomFieldDefinitions = ({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: string[]) =>
      reorderEventCustomFieldDefinitions({ schoolyearId, schoolId, ids }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EVENTS_CUSTOM_FIELDS_KEY, schoolyearId, schoolId],
      });
    },
  });
};
